import { Sprite, Texture } from 'pixi.js';
import Button from './Button';

class SimpleButton extends Button {
	constructor(obj) {
		super(obj);
		if (obj.bg) {
			this.bg = Sprite.from(Texture.from(obj.bg));
			this.addChild(this.bg);
			this.bg.anchor.set(0.5, 0.5);
		}
		if (obj.icon) {
			this.icon = Sprite.from(Texture.from(obj.icon));
			this.bg.addChild(this.icon);
			this.icon.anchor.set(0.5, 0.5);
		}
	}

	getSize() {
		return {
			width: this.bg.width,
			height: this.bg.height
		};
	}
}

export default SimpleButton;
